import { useMemo } from "react"
import { ICircle } from "../../../../types/wizard"

interface Emblem3dSummary {
  items: ICircle[]
}

export const Emblem3dSummary: React.FC<{ content: Emblem3dSummary }> = ({ content }) => {
  const highItems = useMemo(() => content?.items?.filter((item) => item.option === "high"), [content?.items])
  const lowItems = useMemo(() => content?.items?.filter((item) => item.option === "low"), [content?.items])

  return (
    <>
      <div className="flex flex-col self-start text-md font-bold py-1 gap-2">
        {highItems?.length ? (
          <>
            <h2 className="font-bold text-md">{highItems.length} High Dimension Indicated</h2>
            {highItems.map((item, index) => (
                <>
                  {content ? (
                    <div className="flex gap-2 items-center">
                      <div className="rounded-full w-5 h-5 border border-slate-300 bg-black"></div>
                      <p className="capitalize">{item.option! as string} Indicator {index + 1}</p>
                    </div>
                  ) : null}
                </>
            ))}
          </>
        ) : null}
        {lowItems?.length ? (
          <>
            <h2 className="font-bold text-md">{lowItems.length} Low Dimension Indicated</h2>
            {lowItems.map((item, index) => (
                <>
                  {content ? (
                    <div className="flex gap-2 items-center">
                      <div className="rounded-full w-5 h-5 border border-slate-300 bg-black"></div>
                      <p className="capitalize">{item.option! as string} Indicator {index + 1}</p>
                    </div>
                  ) : null}
                </>
            ))}
          </>
        ) : null}
      </div>
    </>
  )
}